/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in page dashboard
 * @created at      :   2024/10/23
 * @created by      :   ANS833 – sondh@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    kubun: 0,
    supervising_department_cd_1: '',
    supervising_department_name_1: '',
    user_id: '',
    user_name: '',
    message_1: '',
    supervising_department_cd_2: '',
    supervising_department_name_2: '',
    customer_cd: '',
    customer_name: '',
    responsible_person_2: '',
    responsible_person_name_2: '',
    message_2: ''
};
export default {
    namespaced: true,
    state: {
        data: {
            ...dataInit
        }
    },
    mutations: {
        setData(state, data) {
            state.data = data ?? { ...dataInit };
        },
        resetData(state) {
            state.data = { ...dataInit };
        }
    },
    actions: {
        /**
         * get user info
         * -----------------------------------------
         * @author : sondh - 2024/10/23 - create
         * @params :
         * @access : private
         */
        storeSave(context, input) {
            try {
                repository.storeSave(input.body).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onError) {
                            input.onError(data.Message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action save: ' + e.message);
            }
        },
        /**
         * getMessageConfirm
         * -----------------------------------------
         * @author : sondh - 2024/12/23 - create
         * @params :
         * @access : private
         */
        getMessageConfirm(context, input) {
            try {
                const cleanInput = structuredClone(input.body);
                delete cleanInput.message_1;
                delete cleanInput.message_2;
                delete cleanInput.customer_name;
                delete cleanInput.supervising_department_name_1;
                delete cleanInput.supervising_department_name_2;
                delete cleanInput.responsible_person_name_2;
                delete cleanInput.user_name;
                repository.getMessageConfirm(cleanInput).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (input.callback) {
                            input.callback(data);
                        }
                    } else if (data.Code === 422) {
                        if (input.onError) {
                            input.onError(data.Message);
                        }
                    }
                });
            } catch (e) {
                console.log('getMessageConfirm: ' + e.message);
            }
        }
    }
};
